import styles from '../custom-select.module.css';

import { ICONS } from '@ui/icons/types';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';
import { CSSProperties } from 'react';

const FakeBorder = ({
  lockActiveState,
  menuOpen,
  maskOverflowColor,
}: {
  lockActiveState: boolean;
  menuOpen: boolean;
  maskOverflowColor?: string;
}) => {
  return (
    <div
      className={`${styles['fake-border']} ${lockActiveState ? styles['show-fake-border'] : ''} ai-center jc-flex-end`}
      style={
        {
          '--custom-select-mask-overflow-color': maskOverflowColor,
        } as CSSProperties
      }
    >
      <div className={`${styles['fake-dropdown-icon']} flex pi-center`}>
        <RotatableIcon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} rotate={menuOpen ? '180deg' : '0'} />
      </div>
    </div>
  );
};

export default FakeBorder;
